/*
 *   File:           rootSaga.ts
 *   Description:    this is where the Sagas comes together
 *   Author:         PreVeil, LLC
 */

/// ADD ALL Local Sagas:
import { accountSaga } from "../account/saga";
import { adminSaga } from "../admin/saga";
import { appSaga } from "../app/saga";
import { mailSaga } from "../mail/saga";
import { wsSaga } from "../websocket/saga";
import { all, fork } from "redux-saga/effects";

export function* rootSaga() {
  yield all([
    fork(wsSaga),
    fork(appSaga),
    fork(accountSaga),
    fork(mailSaga),
    fork(adminSaga)
    // more sagas...
  ]);
}
